var map = {
	"./People_orange.png": 50132,
	"./add-plus-button.png": 85742,
	"./addicon.png": 42409,
	"./appointment-icon.png": 16928,
	"./bars-chart.png": 84399,
	"./blood-donation-icon.png": 21888,
	"./blood-request-icon.png": 49576,
	"./blood-transfusion.png": 45679,
	"./bloodbank-logo.png": 14534,
	"./btn-separate.png": 770,
	"./btn-spin.png": 88786,
	"./calendar.png": 62185,
	"./calendar_circle.png": 24184,
	"./cat-bsc-ideal.png": 87975,
	"./cat-bsc-obese.png": 41946,
	"./cat-bsc-overweight.png": 36771,
	"./cat-bsc-too-thin-1.png": 16297,
	"./cat-bsc-too-thin-2.png": 14007,
	"./check-select.png": 88129,
	"./checked.png": 11014,
	"./chihuahua.jpg": 28701,
	"./circular-clock.png": 33833,
	"./default-upload-owner-profile.png": 59642,
	"./dog-bsc-ideal.png": 81231,
	"./dog-bsc-obese.png": 68720,
	"./dog-bsc-overweight.png": 57211,
	"./dog-bsc-too-thin-1.png": 23890,
	"./dog-bsc-too-thin-2.png": 28975,
	"./drug-icon.png": 8384,
	"./female-sign.png": 21110,
	"./ffp.png": 86866,
	"./file.png": 73295,
	"./fwb.png": 45071,
	"./healthbook-icon.png": 42058,
	"./icon-blood-active.png": 41315,
	"./icon-blood.png": 40494,
	"./icon-calendar-circle2.png": 82603,
	"./icon-camera.png": 82719,
	"./icon-cat-invert.png": 4689,
	"./icon-cat.png": 69655,
	"./icon-check-circle.png": 92696,
	"./icon-check-circle2.png": 89376,
	"./icon-close-circle.png": 17053,
	"./icon-dog-invert.png": 14777,
	"./icon-dog.png": 71193,
	"./icon-edit.png": 3899,
	"./icon-female-sign-white.png": 45089,
	"./icon-female-sign.png": 35167,
	"./icon-male-sign-white.png": 84771,
	"./icon-male-sign.png": 50153,
	"./icon-microchip-circle.png": 40747,
	"./icon-register-circle.png": 56243,
	"./icon-sterilize-circle.png": 62588,
	"./icon-timeline-activity.png": 48399,
	"./icon-timeline-dead.png": 87603,
	"./icon-timeline-microchip.png": 13009,
	"./icon-timeline-sterilize.png": 53245,
	"./icon-vaccine-circle.png": 48246,
	"./icon-vaccine-circle2 - Copy.png": 75093,
	"./icon_dead_report.png": 22712,
	"./icon_microchip.png": 60232,
	"./icon_scan_qr.png": 28559,
	"./icon_sterilize.png": 88332,
	"./icon_vaccine_large.png": 40752,
	"./login-logo.jpg": 73725,
	"./logo.png": 46644,
	"./male-sign.png": 86081,
	"./menu_home.png": 61593,
	"./menu_logout.png": 73123,
	"./menu_microchip.png": 69479,
	"./menu_pet_profile.png": 90384,
	"./menu_report.png": 29611,
	"./menu_sterilize.png": 55392,
	"./menu_vaccine_log.png": 45543,
	"./new-donation.png": 39898,
	"./new-public-request.png": 26950,
	"./new-request.png": 42525,
	"./notepad.png": 21424,
	"./p-rb-cs.png": 36379,
	"./prevention-icon.png": 17922,
	"./profile-box-bg.jpg": 14569,
	"./shapeCat-white.png": 72823,
	"./shapeCat.png": 96642,
	"./shapeDog-white.png": 29139,
	"./shapeDog.png": 9429,
	"./smart-pet-blood-bank.png": 22604,
	"./substract.png": 8250,
	"./syringe.png": 66017
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47745;